export default {
  'loyalty.overview.title': '欢迎回来！您可以在这总览会员项目的状况。',

  'loyalty.range.custom': '自定义',
  'loyalty.range.today': '今天',
  'loyalty.range.yesterday': '昨天',
  'loyalty.range.7d': '7天',
  'loyalty.range.30d': '30天',
  'loyalty.range.3m': '3个月',
  'loyalty.range.12m': '12个月',

  'loyalty.summary.custom': '自定义',
  'loyalty.summary.today': '今天',
  'loyalty.summary.yesterday': '昨天',
  'loyalty.summary.7d': '过去7天',
  'loyalty.summary.30d': '过去30天',
  'loyalty.summary.3m': '过去3个月',
  'loyalty.summary.12m': '过去12个月',

  'loyalty.chart.total_members': '总会员',
  'loyalty.chart.total_members.alias': '总会员(根据注册时间区分)',
  'loyalty.chart.total_members_by_purchase.alias': '总会员(根据上一次消费区分)',
  'loyalty.chart.total_members_by_expiration.alias': '总会员(根据有效期区分)',
  'loyalty.chart.total_members_by_purchase': '总会员(根据上一次消费区分)',
  'loyalty.chart.total_members_by_expiration': '总会员(根据有效期区分)',
  'loyalty.chart.total_visits': '总到访',
  'loyalty.chart.total_cashback': '总返现',
  'loyalty.chart.total_prepaidcard': '充值卡购买人数|总金额',
  'loyalty.chart.total_prepaidcard_title': '{people}人 | {amount}',
  'loyalty.chart.total_sign_up': '总注册',
  'loyalty.chart.member_trends': '会员趋势',
  'loyalty.chart.visits_trends': '到访趋势',
  'loyalty.chart.cashback_trends': '返现趋势',
  'loyalty.chart.signup_source_trends': '注册来源趋势',
  'loyalty.chart.autopilot': '自动营销短信',

  'loyalty.percent.total_members': '占{total}总会员数的百分比',
  'loyalty.percent.total_visits': '占总到访{total}的百分比',
  'loyalty.percent.total_cashback': '占总发出返现{total}的百分比',
  'loyalty.percent.total_sign_up': '占总注册{total}的百分比',
  'loyalty.percent.total_prepaidcard': '占总充值{total}的百分比',

  'loyalty.legend.pending': '待支付',
  'loyalty.legend.new': '新会员',
  'loyalty.legend.regular': '常规会员',
  'loyalty.legend.lowFrequency': '低频会员',
  'loyalty.legend.low_frequency': '低频会员',
  'loyalty.legend.atRisk': '潜在流失会员',
  'loyalty.legend.at_risk': '潜在流失会员',
  'loyalty.legend.lost': '沉默会员',
  'loyalty.legend.recent': '30天内新注册会员',
  'loyalty.legend.active': '激活会员',

  'loyalty.legend.inactive': '沉默会员',
  'loyalty.legend.redeemed': '已兑换',
  'loyalty.legend.unredeemed': '未兑换',
  'loyalty.legend.issued': '发出',
  'loyalty.legend.return_visits': '非新到访',
  'loyalty.legend.new_visits': '新到访',
  'loyalty.legend.in_store': '店内注册',
  'loyalty.legend.qr_code': '扫码',
  'loyalty.legend.smart_ordering': '平板点餐',
  'loyalty.legend.qr_code_ordering': '扫码点餐',
  'loyalty.legend.pos': 'POS APP',
  'loyalty.legend.gift_card': '礼品卡迁移',
  'loyalty.legend.kiosk': '自助点餐机',
  'loyalty.legend.loyalty_web': '网页注册',
  'loyalty.legend.branded_app': '商家品牌App',

  'loyalty.legend.prepaidcard_redeemed': '已使用',
  'loyalty.legend.prepaidcard_unredeemed': '未使用',

  'loyalty.legend.purchase_regular': '常规会员',
  'loyalty.legend.purchase_low_frequency': '低频会员',
  'loyalty.legend.purchase_at_risk': '潜在流失会员',
  'loyalty.legend.purchase_lost': '已流失会员',

  'loyalty.legend.expired.total': '已过期会员',
  'loyalty.legend.expired_7_days': '已过期0～7',
  'loyalty.legend.expired_8_to_30_days': '已过期8～30',
  'loyalty.legend.expired_31_to_90_days': '已过期31～90',
  'loyalty.legend.expired_90_days': '已过期90天',
  'loyalty.legend.unexpired': '未过期',

  'loyalty.definition.purchase_regular': '上一次消费时间在过去30天内的会员',
  'loyalty.definition.purchase_low_frequency': '上一次消费时间在过去31～90天内的会员',
  'loyalty.definition.purchase_at_risk': '上一次消费时间在过去91～180天内的会员',
  'loyalty.definition.purchase_lost': '上一次消费已超过180天的会员',

  'loyalty.percent.total_members_by_purchase': '占总会员(根据上一次消费区分){total}的百分比',

  'loyalty.definition.expired_7_days': '已过期0～7天会员',
  'loyalty.definition.expired_8_to_30_days': '已过期8～30天会员',
  'loyalty.definition.expired_31_to_90_days': '已过期31～90天会员',
  'loyalty.definition.expired_90_days': '已过期90天会员',
  'loyalty.definition.unexpired': '有效期内会员',
  'loyalty.percent.total_members_by_expiration': '占总会员(根据有效期区分){total}的百分比',

  'loyalty.definition.new': '在过去7天内注册的会员',
  'loyalty.definition.recent': '在过去8~30天内注册的会员',
  // 'loyalty.definition.new': '在过去{days}天内注册的会员',
  // 'loyalty.definition.recent': '在过去{days}天内注册的会员',
  'loyalty.definition.regular': '在过去{days}天内在您的餐厅下过单的会员',
  'loyalty.definition.lowFrequency': '在过去{days}天内未在您的餐厅下过单的会员',
  'loyalty.definition.atRisk': '在过去{days}天内未在您的餐厅下过单的会员',
  'loyalty.definition.lost': '在过去{days}天内未在您的餐厅下过单的会员',
  'loyalty.definition.inactive': '在过去{days}天内未在您的餐厅下过单的会员',

  'loyalty.definition.redeemed': '已发出并且已兑换的返现',
  'loyalty.definition.unredeemed': '已发出但未被兑换的返现',
  'loyalty.definition.return_visits': '非新用户产生的订单量',
  'loyalty.definition.new_visits': '新用户产生的订单量',
  'loyalty.definition.in_store': '通过店内台上的广告牌的会员注册',
  'loyalty.definition.qr_code': '通过扫码点餐网站的会员注册',
  'loyalty.definition.kiosk': '通过点餐机注册',
  'loyalty.definition.pos': '通过店内POS App 注册',

  'loyalty.definition.prepaidcard_redeemed': '充值卡购买并且已经被使用的',
  'loyalty.definition.prepaidcard_unredeemed': '充值卡购买但被使用的',

  'loyalty.manualcampaign.title': '手动短信营销',
  'loyalty.manualcampaign.action.createCampaign': '创建',
  'loyalty.manualcampaign.action.editCampaign': '编辑',
  'loyalty.manualcampaign.action.duplicateCampaign': '复制',
  'loyalty.manualcampaign.createCampaign.title': '创建手动营销短信',
  'loyalty.manualcampaign.editCampaign.title': '编辑手动营销短信',
  'loyalty.manualcampaign.action.cancel': '取消',
  'loyalty.manualcampaign.action.save': '保存',
  'loyalty.manualcampaign.campaignName.title': '活动名',
  'loyalty.manualcampaign.campaignForeignName.title': '活动中文名',
  'loyalty.manualcampaign.campaignDesc.title': '活动描述',
  'loyalty.manualcampaign.campaignForeignDesc.title': '活动中文描述',
  'loyalty.manualcampaign.campaignContent.en.title': '活动内容 - 英文',
  'loyalty.manualcampaign.campaignContent.zh.title': '活动内容 - 中文',
  'loyalty.manualcampaign.target': '目标用户类型',
  'loyalty.manualcampaign.field.target.placeholder': '请选择目标用户类型',
  'loyalty.manualcampaign.target.estimated.title': '预计发送用户数:',
  'loyalty.manualcampaign.target.expected.segments.title': '预计发送段数:',
  'loyalty.manualcampaign.target.remain.segments.title': '套餐内剩余可用段数:',
  'loyalty.manualcampaign.target.package.exceed.tips':
    '套餐内剩余可用段数0,超出套餐的部分将按实际超出量额外收取$0.02/段',
  'loyalty.manualcampaign.target.estimatedUserTotal': '总数量:',
  'loyalty.manualcampaign.target.estimatedSMSTotal': '短信数:',
  'loyalty.manualcampaign.charge.estimated.title': '预计费用:',
  'loyalty.manualcampaign.charge.estimatedUserTotal': '总费用:',
  'loyalty.manualcampaign.charge.estimatedSMSTotal': '短信费用:',
  'loyalty.manualcampaign.scheduledDelivery.title': '发送时间',
  'loyalty.manualcampaign.scheduledDelivery.placeholder': '请选择发送时间',
  'loyalty.manualcampaign.scheduledDelivery.expired': '选择的发送时间不能小于当前时间',
  'loyalty.manualcampaign.scheduledDelivery.startTime': '时间',
  'loyalty.manualcampaign.scheduledDelivery.onDate': '日期',
  'loyalty.manualcampaign.status.title': '活动状态',
  'loyalty.manualcampaign.sms.sent': '送达',
  'loyalty.crm.sms.segments': '已发送段数',
  'loyalty.manualcampaign.target.expirdRange': '过期范围',
  'loyalty.manualcampaign.field.expiredDateRangeStart.required': '必需',
  'loyalty.manualcampaign.field.expiredDateRangeEnd.required': '必需',
  'loyalty.manualcampaign.field.expiredDateRange.error': '过期范围设置错误',

  'loyalty.campaign.subscribed': '激活',
  'loyalty.campaign.unsubscribed': '未激活',
  'loyalty.autocampaign.action.editCampaign': '编辑',
  'loyalty.autopilotcampaign.editCampaign.title': '编辑自动营销短信',
  'loyalty.autopilotcampaign.action.cancel': '取消',
  'loyalty.autopilotcampaign.action.save': '保存',

  'loyalty.campaign.subscribed.desc': '状态:激活',
  'loyalty.campaign.unsubscribed.desc': '状态:未激活',
  'loyalty.campaign.type.SMS.desc': '类型:短信',
  'loyalty.campaign.type.MMS.desc': '类型:彩信',

  'loyalty.manualcampaign.field.name.placeholder': '请输入活动名',
  'loyalty.manualcampaign.field.name.required': '请输入活动名',
  'loyalty.manualcampaign.field.desc.placeholder': '请输入活动描述',
  'loyalty.manualcampaign.field.desc.required': '请输入活动描述',
  'loyalty.manualcampaign.field.content.required': '请输入文字内容',
  'loyalty.manualcampaign.field.sensitive': '该文案含有敏感词“敏感词内容”',
  'loyalty.manualcampaign.field.scheduledDelivery.required': '请选择发送时间',
  'loyalty.manualcampaign.field.content.placeholder': '在短信/彩信中用户看到的文字内容',
  'loyalty.manualcampaign.field.content.addVariables': '添加变量',
  'loyalty.manualcampaign.field.content.length.tips': '英文150个字符以内，中文65个字符以内',
  'loyalty.manualcampaign.field.userSegment.required': '请选择目标用户类型',
  'loyalty.manualcampaign.content.exceed': '内容长度超过限制:英文150个字符以内，中文65个字符以内',
  'loyalty.manualcampaign.create.success': '活动创建成功',
  'loyalty.manualcampaign.create.failed': '活动创建失败',
  'loyalty.manualcampaign.update.success': '活动更新成功',
  'loyalty.manualcampaign.update.failed': '活动更新失败',
  'loyalty.autopilotcampaign.update.success': '活动更新成功',
  'loyalty.autopilotcampaign.update.failed': '活动更新失败',
  'loyalty.campaign.field.content.length.tips': '{charCount} | {billableSegments} 预计收费段数',
  'loyalty.campaign.content.segments.exceed': '最多发送10个预计收费段数',
  'loyalty.campaign.field.content.length.tips.MMS': '{charCount} | 1,560 字符',
  'loyalty.campaign.field.content.MMS.popover': 'MMS消息中含有多媒体文件和消息正文，消息正文最多输入 1,560个字符。',
  'loyalty.campaign.content.MMS.exceed': '最多发送 1,560个字符',

  'loyalty.autopolit.title': '自动发送',

  'loyalty.userSegment.new': '新会员',
  'loyalty.userSegment.regular': '常规会员',
  'loyalty.userSegment.atRisk': '风险会员',
  'loyalty.userSegment.lost': '沉默会员',
  'loyalty.userSegment.inactive': '沉默会员',
  'loyalty.userSegment.all': '所有',

  'loyalty.chart.autopilot_new_register_trends': 'Autopilot新会员',
  'loyalty.chart.autopilot_first_purchase_trends': 'Autopilot首单用户促活',
  'loyalty.chart.autopilot_repurchase_trends': 'Autopilot再次下单促活',
  'loyalty.chart.autopilot_at_risk_trends': 'Autopilot风险会员促活',
  'loyalty.chart.autopilot_lost_trends': 'Autopilot流失会员促活',
  'loyalty.chart.manual_campaign_trends': '手动营销短信',
  'loyalty.autocampaign.campaignSentInfo': '已发送:{sent} 已送达:{delivered}',
  'loyalty.autocampaign.show.last7day.sentInfo': '查看最近7天发送数据',
  'loyalty.autocampaign.hide.last7day.sentInfo': '收起最近7天发送数据',

  'loyalty.legend.manual_camgaign_send': '发送量',

  'loyalty.legend.count': '发送量',

  'loyalty.legend.sms': '短信',
  'loyalty.legend.mms': '彩信',

  'loyalty.campaign.content.addPersonalization': '添加变量',
  'loyalty.campaign.content.addPersonalization.confirm.button': '插入变量',
  'loyalty.campaign.content.addPersonalization.cancel.button': '取消',

  'loyalty.segments.usage.title': 'CRM短信使用情况 ({month})',
  'loyalty.segments.usage.used': '已用:',
  'loyalty.segments.usage.actualUsed': '实际使用:',
  'loyalty.segments.usage.monthlyCapacity': '月可用:',

  'loyalty.campaign.SMS.usage.sent': '短信已发送人数:{sms_sent}',
  'loyalty.campaign.SMS.usage.segments.sent': '短信已发送段数:{sms_segments_sent}',

  'loyalty.campaign.MMS.usage.sent': '彩信已发送人数:{mms_sent}',
  'loyalty.campaign.MMS.usage.segments.sent': '彩信已发送段数:{mms_segments_sent}',

  'loyalty.points.settings.title': '会员积分设置',
  'loyalty.points.settings.accumulation.title': '会员积分累计',
  'loyalty.points.settings.accumulation.title.RG': '会员积分累计 - RG',
  'loyalty.points.settings.accumulation.desc.consuming': '每消费',
  'loyalty.points.settings.accumulation.desc.get': '可获得积分',
  'loyalty.points.settings.accumulation.desc.post': '',
  'loyalty.points.settings.accumulation.summary':
    '每消费${consumingAmount},获取{points}个积分，不足${consumingAmount}时，不累计，默认所有消费都能获取积分',
  'loyalty.points.settings.redemption.title': '积分兑换',
  'loyalty.points.settings.accumulation.desc.consuming.isrequired': '消费金额不能为空',
  'loyalty.points.settings.accumulation.desc.get.isrequired': '获得积分不能为空',

  'loyalty.point.redemption.table.column.menuName': '菜单',
  'loyalty.point.redemption.table.column.categoryName': '类别',
  'loyalty.point.redemption.table.column.mealName': '菜品',
  'loyalty.point.redemption.table.column.pointPrice': '消耗积分',

  'loyalty.points.report.title': '会员积分报表',
  'loyalty.point.report.summary.totalGrant': '积分发放总数',
  'loyalty.point.report.summary.totalRedeem': '总兑换数',
  'loyalty.point.report.RG.restaurantFilter': '按餐厅筛选',

  'pointsReport.column.order_number': '订单号',
  'pointsReport.column.phone_number': '手机号',
  'pointsReport.column.member_card_number': '会员卡号',
  'pointsReport.column.name': '会员名',
  'pointsReport.column.product_names': '兑换商品名',
  'pointsReport.column.action_type': '积分类型',
  'pointsReport.column.created_at': '时间',
  'pointsReport.column.points': '积分变动',
  'pointsReport.column.balance': '积分结余',
  'pointsReport.column.pointsSource': '变动来源-餐厅',
  'loyalty.sms.segmetns.explain.content': `什么是短消息段？
  短消息服务（SMS）是一种标准化的通信协议，使设备能够发送和接收简短的文本消息。它的设计是为了“适应”其他信令协议，这就是为什么SMS消息长度被限制在160个7位字符，即1120位，或140字节。SMS消息段是电话运营商用来测量文本信息的字符批次。消息是按消息段收取费用的，因此利用SMS的客户端从理解消息将如何分割的细微差别中获益良多。
  当您创建SMS活动时，生成的消息代表当消息发送到用户的手机时，用户可能会看到的内容，但并不表示您的消息将如何分割成段，以及最终如何向您收费。了解将发送多少段并注意可能发生的潜在溢出是您的责任，但我们提供了一些资源来简化这一过程。`,
  'loyalty.sms.segmetns.explain.reminder': '根据运营商要求，信息中要加入退订提示，且提示也将计入短信/彩信字符统计中。',

  'loyalty.points.settings.accumulation.availability.meals.title': '积分适用商品',
  'loyalty.points.settings.accumulation.scope.title': '适用商品',
  'loyalty.points.settings.accumulation.scope.option.all': '全部商品可用',
  'loyalty.points.settings.accumulation.scope.option.excluding': '排除部分商品',
  'loyalty.points.settings.accumulation.scope.excluding.category.title': '排除分类',
  'loyalty.points.settings.accumulation.scope.excluding.category.subtitle': '选择分类',
  'loyalty.points.settings.accumulation.scope.excluding.category.tips':
    '（如选择“指定类别”，后期分类中增加菜品自动适用当前活动）',
  'loyalty.points.settings.accumulation.scope.excluding.meal.title': '排除商品',
  'loyalty.points.settings.accumulation.scope.excluding.meal.subtitle': '选择商品',
  'loyalty.points.settings.accumulation.scope.excluding.meal.tips': ' ',

  'loyalty.points.settings.accumulation.availability.save.success': '积分适用商品保存成功',
  'loyalty.points.settings.accumulation.availability.save.fail': '积分适用商品保存失败',

  'loyalty.points.settings.accumulation.scope.switch.confirm': '确认全部商品可累计积分?',

  'loyalty.points.settings.accumulation.scope.editor.selectCategory': '选择分类（积分分类不可选）:',
  'loyalty.points.settings.accumulation.scope.editor.selectedCategory': '已选择分类:',
  'loyalty.points.settings.accumulation.scope.editor.clearAllSelectedCategories': '清空所有选项',
  'loyalty.points.settings.accumulation.scope.editor.selectedMeal': '已选择菜品:',
  'loyalty.points.settings.accumulation.scope.editor.clearAllSelectedMeals': '清空所有选项',

  'loyalty.sensitive.sentence1':
    'SMS单消息段长度，限制在160个7位字符，即1120位，或140字节。当内容长度超过该限制时，运营商会将内容分成多个消息段。',
  'loyalty.sensitive.sentence2':
    'MMS消息中包含多媒体文件和消息正文两部分，文件总大小限制 600 KB，消息正文限制 1,560个字符以内。运营商将会按MMS消息的数量收取费用。',
  'loyalty.sensitive.sentence3':
    '出现以下情况，运营商不会发出短信：含有敏感词，例如电子烟、海洛因、毒品、香烟等；电话号码被运营商放入了黑名单。',
  'loyalty.sensitive.sentence4': '根据运营商要求，信息中要加入退订提示，且提示也将计入短信字符统计中。',

  'loyalty.campaign.form.card.setting.title': '设置',
  'loyalty.campaign.form.card.setting.status.field.title': '营销活动状态',
  'loyalty.campaign.form.card.setting.type.field.title': '营销活动形式',
  'loyalty.campaign.form.card.setting.type.option.SMS': '短信',
  'loyalty.campaign.form.card.setting.type.option.MMS': '彩信',

  'loyalty.campaign.form.card.content.title': '内容',
  'loyalty.campaign.SMS.content.reviewer.tips': `不同手机显示效果不同，请以实际发送效果为准。
  根据运营商要求，信息中要加入退订提示，且提示也将计入短信/彩信字符统计中。`,
  'loyalty.campaign.MMS.content.reviewer.tips': `图片大小600K以内；图片格式支持.jpeg，.gif，.png。
  不同手机显示效果不同，请以实际发送效果为准。
  根据运营商要求，信息中要加入退订提示，且提示也将计入短信/彩信字符统计中。`,

  'loyalty.campaign.unsubscribe.tips.en': 'Reply T to unsubscribe',
  'loyalty.campaign.unsubscribe.tips.zh': '回复T退订',

  'loyalty.campaign.MMS.media.upload': '上传图片',
  'loyalty.campaign.tabs.title': '短信和彩信营销',

  'loyalty.manualcampaign.table.column.name': '活动名称',
  'loyalty.manualcampaign.table.column.segment_id': '目标用户',
  'loyalty.manualcampaign.table.column.document_status': '状态',
  'loyalty.manualcampaign.table.column.campaign_type': '形式',
  'loyalty.manualcampaign.table.column.message_type': '形式',
  'loyalty.manualcampaign.table.column.delivery_at': '发送时间',
  'loyalty.manualcampaign.table.column.segments_count': '发送段数',
  'loyalty.manualcampaign.table.column.sent_count': '发送人数',
  'loyalty.manualcampaign.table.column.operator': '操作',

  'loyalty.campaign.type.SMS': '短信',
  'loyalty.campaign.type.MMS': '彩信',
  'loyalty.manualcampaign.table.column.segments_count.tips': '短信形式，显示信息段数量。彩信形式，显示彩信条数。',
  'loyalty.manualcampaign.table.column.sent_count.tips': '短信形式，显示信息段数量。彩信形式，显示彩信条数。',
  'loyalty.manualcampaign.query.placeholder': '按活动名称搜索',
  'loyalty.manualcampaign.filter.search': '关键字搜索',
  'loyalty.manualcampaign.filter.action.clear': '清空',
  'loyalty.manualcampaign.filter.targetuser': '目标用户',
  'loyalty.manualcampaign.filter.status': '状态',
  'loyalty.manualcampaign.filter.type': '形式',

  'loyalty.manualcampaign.filter.targetuser.placeholder': '请选择目标用户',
  'loyalty.manualcampaign.filter.status.placeholder': '请选择状态',
  'loyalty.manualcampaign.filter.type.placeholder': '请选择形式',
  'loyalty.campaign.service.agreement': 'CRM 短彩信服务条款',
  'loyalty.campaign.confirm.services': '同意协议，开始使用',
  'loyalty.campaign.service.agreement.for.employee': '请确认服务协议后使用',
  'loyalty.campaign.service.agreement.for.employee.content':
    '请餐厅老板确认新服务协议，新增加了彩信服务，并优化了短信收费方式。',

  'loyalty.campaign.subscribe.checking': '正在检查CRM订阅',
  'loyalty.campaign.subscribe.confirming': '正在确认新的CRM短彩信协议',
  'loyalty.campaign.MMS.imageUploadGuide.sizeTooLarge': '图片尺寸限制在600K以内',
  'loyalty.campaign.MMS.imageUploadGuide.formatNotMatched': '图片格式必须为 .jpg, .jpeg, .png, .gif',
  'loyalty.campaign.MMS.media.required': '请上传图片',

  'loyalty.twilio.modal.title': 'CRM的短信/彩信营销号码注册表',
  'loyalty.twilio.modal.content.title':
    '欢迎使用我们的短信和彩信营销服务。为了给您提供更好的短信和彩信营销服务，请填写以下信息并审阅服务条款。',
  'loyalty.twilio.modal.point_contract': '联系人',
  'loyalty.twilio.modal.business_information': '店铺信息',
  'loyalty.twilio.modal.checkbox.content':
    '我同意对通过Chowbus CRM系统给客人发送的SMS和MMS消息内容全权负责，并承诺遵守信息内容有关的所有当地法律和法规。我同意Chowbus的短信和彩信运营商有权在发生任何违规行为时终止此服务，且Chowbus无法控制此类情况。我理解运营商的发送速度上限为每秒3段信息，所以部分收件人可能无法在发送后立即收到消息。我同意Chowbus Restaurant Technology Agreement的原条款同样适用于此服务。',
  'loyalty.twilio.modal.register.btn': '注册',
  'loyalty.twilio.modal.cancel.btn': '取消',
  'loyalty.twilio.modal.skip.btn': '稍后注册',
  'loyalty.twilio.modal.applied.btn': '已申请',
  'loyalty.twilio.modal.valid.not_allowed_chinese': '不能填写中文',
  'loyalty.twilio.modal.valid.only_number': '只能输入数字',
  'loyalty.twilio.modal.valid.email': '邮箱格式不正确!',

  'loyalty.twilio.modal.required.email': '请输入电子邮件地址!',
  'loyalty.twilio.modal.required.phone': '请输入手机号!',
  'loyalty.twilio.modal.required.first_name': '请输入名!',
  'loyalty.twilio.modal.required.last_name': '请输入姓!',
  'loyalty.twilio.modal.required.business_name': '请输入公司名称!',
  'loyalty.twilio.modal.required.address_one': '请输入街道地址 1!',
  'loyalty.twilio.modal.required.city': '请输入城市!',
  'loyalty.twilio.modal.required.zip_code': '请输入邮政编码!',
  'loyalty.twilio.modal.required.business_website': '请输入公司网址!',
  'loyalty.twilio.modal.required.state': '请选择州!',
  'loyalty.twilio.modal.required.country': '请选择国家!',

  'loyalty.twilio.account.my_account': '我的账户',
  'loyalty.twilio.account.table.message_number': '营销号码',
  'loyalty.twilio.account.table.submitted_by': '注册人',
  'loyalty.twilio.account.table.submission_time': '注册时间',
  'loyalty.twilio.account.table.email_address': '邮箱地址',
  'loyalty.twilio.account.table.Status': '状态',
  'loyalty.twilio.account.table.action': '操作',
  'loyalty.twilio.application.rejected': '申请未通过',
  'loyalty.twilio.application.rejected.later': '稍后',
  'loyalty.twilio.application.rejected.modify': '编辑',
  'loyalty.twilio.application.wrong': '哎呀，申请出错了！',
  'loyalty.twilio.application.wrong.content': '请联系我们的客服以获取帮助',
  'loyalty.twilio.application.wrong.btn': '返回',
  'loyalty.twilio.rejected.inform':
    '我们遗憾地通知您，您的CRM短信/彩信营销号码申请未通过。请检查并修改提供的信息，然后重新提交您的申请。',
  'loyalty.twilio.skip.title': '您现在想跳过这一步吗？?',
  'loyalty.twilio.skip.content': '您可以随时通过访问CRM账户页面来完成您的申请。',

  'loyalty.twilio.account.drawer.title': '申请历史',
  'loyalty.twilio.account.status.pending': '处理中',
  'loyalty.twilio.account.status.activated': '已激活',
  'loyalty.twilio.account.status.rejected': '拒绝',
  'loyalty.twilio.account.status.reseted': '已重置',
};
